import React from 'react'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import DOMPurify from 'dompurify'

let UserConfirmationModal = ({modal, toggle, submit, className, title, text}) =>
    <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text)}}>
        </ModalBody>

        {(submit ?
            <ModalFooter>
                <Button color="primary" onClick={submit}>OK</Button>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter> :
            <ModalFooter>
                <Button color="primary" onClick={toggle}>OK</Button>
            </ModalFooter>)}
    </Modal>

export default UserConfirmationModal



// WEBPACK FOOTER //
// ./src/components/ui/UserConfirmationModal.js